<template>
  <td>
    <div class="btn-group" v-if="needsUpdate">
      <button class="btn btn-success" @click="accept()">
        <i class="fas fa-check" />
      </button>
      <button class="btn btn-danger" @click="decline()">
        <i class="fas fa-trash" /> Löschen
      </button>
    </div>
    <div v-else>
      <button class="btn btn-danger" @click="revert()">
        <i class="fas fa-trash" /> Löschen
      </button>
    </div>
  </td>
</template>

<script>
export default {
  props: ["model", "review"],
  methods: {
    accept() {
      this.$emit("removeModel");
      this.$emit("action", "accept");
    },
    decline() {
      this.$emit("removeModel");
      this.$emit("action", "decline");
    },
    revert() {
      this.$emit("removeModel");
      this.$emit("action", "delete");
    }
  },
  computed: {
    needsUpdate() {
      return !this.review.resolved;
    }
  }
};
</script>

<style></style>
